module.exports = __webpack_public_path__ + "img/aboutUsBannerImg.5f2998bd.png";